// useNavigationManager.js
import { getSessionOptions } from '../redux/slice/tanProfileSlice'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

export function useNavigationManager() {
    const letsGo = useNavigate();
    const location = useLocation();
    const sessionOptions = useSelector(getSessionOptions);
    const tanProfile = useSelector((state) => state?.tanProfile);
    const sessionTypes = tanProfile?.profileMeta?.sessionTypes;

    const locationParts = {
        segment1: location.pathname.split('/')[1],
        segment2: location.pathname.split('/')[2],
    };
    const sessionSelection = locationParts.segment2 !== "sessionSelection";

    const navOptions = [
        { segment: "profileSelection", nav: false },
        { segment: "sessionSelection", nav: false },
        // { segment: "photoSelection", nav: false },
        { segment: "capturePhoto", nav: false },
        { segment: "tanSelection", nav: false },
        { segment: "WellFit", nav: false },
        { segment: "moisturizer", nav: false },
        { segment: "bronzers", nav: false },
        { segment: "scents", nav: false },
        { segment: "accelerator", nav: false },
        { segment: "confirmSession", nav: true },
        { segment: "selectPaymentMethod", nav: false },
        { segment: "finalizeSesssion", nav: false },
    ];

    const allowSessionSelection = () => {
        if (tanProfile?.profileMeta?.profileType !== "edit") {
            navOptions.find(option => option.segment === "sessionSelection").nav = true;
        }
    };

    switch (tanProfile?.profileMeta?.profileType) {
        case "scanBooth":
            navOptions.find(option => option.segment === "profileSelection").nav = true;
            navOptions.find(option => option.segment === "selectPaymentMethod").nav = true;
            navOptions.find(option => option.segment === "finalizeSesssion").nav = true;
            break;
        case "edit":
        case "new":
        case "booth":
            allowSessionSelection();
            break;
    }

    if ((tanProfile?.profileMeta?.profileType === "scanBooth" ? tanProfile?.profileMeta?.navigationDirection !== "edit" : true)) {
        if ((sessionOptions["Tan"] || sessionOptions["Rapid"]) && (sessionTypes?.includes("tan") || sessionTypes?.includes("tanfit"))) {
            ["tanSelection"].forEach(seg => {
                navOptions.find(option => option.segment === seg).nav = true;
            });
            if (sessionOptions["Moisturizer"]) navOptions.find(option => option.segment === "moisturizer").nav = true;
            if (sessionOptions["Bronzer"]) navOptions.find(option => option.segment === "bronzers").nav = true;
            if (sessionOptions["Scent"]) navOptions.find(option => option.segment === "scents").nav = true;
            if (sessionOptions["Accelerator"]) navOptions.find(option => option.segment === "accelerator").nav = true;
        }
        if (sessionOptions["WellFit"] && (sessionTypes?.includes("wellfit") || sessionTypes?.includes("tanfit"))) {
            navOptions.find(option => option.segment === "WellFit").nav = true;
            if (sessionOptions["Scent"]) navOptions.find(option => option.segment === "scents").nav = true;
        }
    }

    const currentIndex = navOptions.findIndex(option => option.segment === locationParts.segment2);

    let prevIndex = currentIndex;
    for (let i = currentIndex - 1; i >= 0; i--) {
        if (navOptions[i].nav) {
            prevIndex = i;
            break;
        }
    }

    const navigate = (forward) => {
        const navHelper = (i) => {
            if (navOptions[i].nav) {
                letsGo(`/${locationParts.segment1}/${navOptions[i].segment}`);
                return true;
            }
        };

        if (forward) {
            for (let i = currentIndex + 1; i < navOptions.length; i++) {
                if (navHelper(i)) break;
            }
        } else {
            for (let i = currentIndex - 1; i >= 0; i--) {
                if (navHelper(i)) break;
            }
        }
    };

    return {
        currentIndex,
        prevIndex,
        navigate,
        sessionSelection
    };
}
